
import { PageBody } from '../../../elements/page-body';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { VehiculosForm } from './vehiculos-form';

export const VehiculosCreate = () => {

    const { t } = useTranslation() as { t: (key: string) => string };
    const navigate = useNavigate();

    return (
        <>
            <div
                className="pt-8 pl-8 cursor-pointer"
                onClick={() => navigate(-1)}
            >
                <span className='text-black pt-[5px]'>{'< '}</span>
                <span className='text-black text-[12px]'>{t('common.button.back')}</span>
            </div>
            <PageBody

                title={'common.label.vehiculo'}

            >
                <>
                    <VehiculosForm isEdit={false} />

                </>
            </PageBody>
        </>

    );
};

